import { Button, Col, Label } from "reactstrap";
import { DateInputField } from "../../../../CommonElements";
import { useState } from "react";
import { getDateToday } from "../../../../Utils/externalFunctions";
import FilterDropdown from "../../../FilterComponents/FilterDropdown";

const DateFilterComponent = ({ updateDateFilter, options, setState, state, filter=false }) => {
  const [dateFilter, setDateFilter] = useState(getDateToday("original"));

  return (
    <div className="d-flex flex-row flex-wrap gap-1">
      <Col md={2} className="d-flex">
        <Label className={"m-0"}>Tanggal</Label>
      </Col>
      <Col md={3}>
        <DateInputField
          // label={"Tanggal"}
          className={"m-0"}
          onChange={(e) => {
            setDateFilter(e.target.value);
            updateDateFilter(e.target.value);
          }}
          value={dateFilter}
        />
      </Col>
      {
        filter && (
          <FilterDropdown
            options={options}
            setState={setState}
            state={state}
          />
        )
      }
      <Col md={3}>
        <Button
          color="primary"
          onClick={() => {
            setDateFilter(getDateToday("original"));
            updateDateFilter(getDateToday("original"));
          }}
        >
          Lihat Hari Ini
        </Button>
      </Col>
    </div>
  );
};

export default DateFilterComponent;
